<script>
  export let error;
</script>

<h1>{error}</h1>
